function sameRoad(left, right) {
    return !!left && !!right &&
        left.zone === right.zone &&
        left.portal === right.portal &&
        left.size === right.size &&
        !!left.expires && !!right.expires &&
        left.expires.hours === right.expires.hours &&
        left.expires.minutes === right.expires.minutes &&
        left.expires.seconds === right.expires.seconds;
}

export {sameRoad};